import Vue from "vue";
import Vuex from "vuex";
import Web3 from "web3";

import createPersistedState from "vuex-persistedstate";
import { connectWallet } from "@/utils/index.js";
import { toLogin, toBindUser, toVerify, toCheckUserBind } from "@/api/index.js";
import i18n from "@/lang";

import router from "@/router";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isLand: "zh",
    address: "",
    token: "",
    inviteCode: "",
    userId: null,
    // 是否是全屏
    fullScreen: false,
    // 登录状态
    isLoginState: false,
    show: false,
    nonce: "",
  },
  mutations: {
    SET_ISLOGINSTATE(state, str) {
      state.isLoginState = str;
    },
    SET_FULLSCREEN(state, str) {
      state.fullScreen = str;
    },
    SET_ISLANGD(state, str) {
      state.isLand = str;
    },
    SET_TOKEN(state, str) {
      state.token = str;
    },
    SET_ADDRESS(state, str) {
      state.address = str;
    },
    SET_ClEAR(state, str) {
      state.token = "";
      state.isLoginState = false;
      state.address = "";
      state.inviteCode = "";
      state.nonce = "";
      state.show = false;
      // sessionStorage.removeItem("token");
      state.userId = null;
      state.fullScreen = false;
    },
    SET_USERID(state, str) {
      state.userId = str;
    },
    SET_INVITECODE(state, str) {
      state.inviteCode = str;
    },
    SET_NONCE(state, str) {
      state.nonce = str;
    },
    SET_SHOW(state, str) {
      state.show = str;
    },
  },
  actions: {
    async clearAuthData({ commit }) {
      commit("SET_ClEAR");
      sessionStorage.clear();
    },
    async loginStore({ commit }) {
      try {
        const address = await connectWallet();
        const oldAdr = store.state.address;
        commit("SET_ADDRESS", address);
        const isDifferentAddress = address != oldAdr;
        const isMissingToken = !sessionStorage.getItem("token");
        if (!oldAdr || isDifferentAddress || isMissingToken) {
          // await this.dispatch("getlogin", address);
          // await this.dispatch("getVerify", address)
          await this.dispatch("getCheckUserBind", address);
        }
      } catch (error) {
        Vue.prototype.$toast(error);
      }
    },
    async getCheckUserBind({ commit }, address) {
      try {
        let p = await toCheckUserBind({ account: address });

        if (p.code == 1) {
          console.log(p, "p");
          // 可以邀请人
          // commit("SET_SHOW", true);
          await this.dispatch("getVerify", address);
        } else {
          // 不能邀请人
          commit("SET_SHOW", false);
          // Vue.prototype.$toast(p.msg);
          setTimeout(async () => {
            await this.dispatch("getVerify", address);
          }, 2000);
        }
      } catch (error) {
        console.log(error, "error");
        Vue.prototype.$toast(error?.message);
      }
    },
    async getVerify({ commit, state }, address) {
      try {
        let p = await toVerify({ addr: state.address });

        if (p.code == 1) {
          await this.dispatch("getlogin", p.data.data);
        } else {
          Vue.prototype.$toast(p.msg);
        }
      } catch (error) {
        Vue.prototype.$toast(error?.message);
      }
    },

    async getlogin({ commit, state }, signinfo) {
      try {
        let addr = state.address;
        const web3 = new Web3(window.ethereum);
        const nonce = signinfo || "";
        const message = `I have read and accept the terms and conditions.${nonce}`;
        let signature = await web3.eth.personal.sign(message, addr);
        let res = await toLogin({
          account: addr,
          sign: signature,
          code: state.inviteCode,
        });
        if (res.code == 1) {
          commit("SET_USERID", res.data.userinfo);
          commit("SET_SHOW", false);
          sessionStorage.setItem("token", res.data.userinfo.token);
          commit("SET_TOKEN", res.data.userinfo.token);
          commit("SET_ADDRESS", addr);
          commit("SET_ISLOGINSTATE", true);
          Vue.prototype.$toast(res.msg);
          // setTimeout(() => {
          //   // router.push("/");
          //   // if (state.inviteCode && res.data.userinfo.real_parent_id == 0) {
          //   //   toBindUser({ account: state.inviteCode }).then(res => {
          //   //     Vue.prototype.$toast(res.msg);
          //   //   })
          //   // }
          // }, 2000);
        } else {
          // Vue.prototype.$toast(i18n.t("000"));
          Vue.prototype.$toast(res.msg);
        }
      } catch (error) {
        Vue.prototype.$toast(error);
      }
    },
  },
  plugins: [
    createPersistedState({
      key: "config_date",
      paths: [
        "isLand",
        "token",
        "address",
        "inviteCode",
        "userId",
        "fullScreen",
        "isLoginState",
        "show",
      ],
    }),
  ],
});
export default store;
